
<template>
    <div>
        <Drawer :closable="false" placement="right" v-model="drawerVisible" width="50%" :title="drawerTitle"
                destroy-on-close="true">
            <Row>
                <Col>
                    <Card :shadow="false">
                        <Row>
                            <Form ref="form" :model="form" :label-width="100" style="position:relative"
                                  :rules="formValidate">
                                <FormItem label="模块名称" prop="title">
                                    <Input v-model="form.title" style="width:600px"/>
                                </FormItem>
                                <FormItem label="导航标题">
                                    <Input v-model="form.barTitle" style="width:600px"/>
                                </FormItem>
                                <FormItem label="页面路径" >
                                    <Input :disabled = "true" v-model="form.path" style="width:600px"/>
                                </FormItem>
                                <FormItem label="排序位置" prop="sort">
                                    <InputNumber v-model="form.sort" style="width:600px"/>
                                </FormItem>
                                <FormItem label="模块类型">
                                    <RadioGroup v-model="form.type">
                                        <Radio :label="1">常规考试</Radio>
                                        <Radio :label="4">评价/认定</Radio>
                                        <Radio :label="2">评价</Radio>
                                        <Radio :label="3">认定</Radio>
                                        <Radio :label="5">我的证书</Radio>
                                        <Radio :label="6">我的成绩</Radio>
                                        <Radio :label="7">评价成绩</Radio>
                                        <Radio :label="8">认定成绩</Radio>
                                        <Radio :label="9">我的学习</Radio>
                                        <Radio :label="10">首页</Radio>
                                        <Radio :label="11">个人中心</Radio>
                                    </RadioGroup>
                                </FormItem>
                                <FormItem v-if="form.type==11" label="特殊类型">
                                    <el-select v-model="form.centerType">
                                        <el-option label="默认类型" :value="0"></el-option>
                                        <el-option label="证书" :value="5"></el-option>
                                        <el-option label="成绩" :value="6"></el-option>
                                        <el-option label="学习" :value="9"></el-option>
                                    </el-select>
                                </FormItem>
                                <FormItem v-if="form.type==7 || form.type==8" label="是缴费报考成绩">
                                    <i-switch
                                        size="large"
                                        v-model="form.orderExam"
                                        :true-value="1"
                                        :false-value="0"
                                    >
                                        <span slot="open">是</span>
                                        <span slot="close">否</span>
                                    </i-switch>
                                </FormItem>
                                <FormItem v-if="form.type==6" label="成绩类型">
                                    <RadioGroup v-model="form.scoreType">
                                        <Radio :label="1">常规考试</Radio>
                                        <Radio :label="7">评价考试</Radio>
                                        <Radio :label="8">认定成绩</Radio>
                                    </RadioGroup>
                                </FormItem>
                                <FormItem v-if="form.type ==2 || form.type==3 || form.type==10" label="是否报名" >
                                    <RadioGroup v-model="form.applyYes">
                                        <Radio :label="0">非报名</Radio>
                                        <Radio :label="1">报名</Radio>
                                        <Radio :label="2">培训</Radio>
                                    </RadioGroup>
                                </FormItem>
                                <FormItem v-if="cerRadioShow" label="证书类型">
                                    <RadioGroup v-model="form.cerType">
                                        <Radio :label="2">1+X</Radio>
                                        <Radio :label="1">认定证书</Radio>
                                        <Radio :label="3">评价证书</Radio>
                                        <Radio :label="4">其他证书</Radio>
                                    </RadioGroup>
                                </FormItem>
                                <FormItem v-if="examTypeShow" label="考试分类">
                                    <!-- 多选选择器 -->
                                        <tree-select
                                            :groupTree="examTypes"
                                            :groupChosenIds="form.examTypeList"
                                            :showCheckbox="true"
                                            :checkStrictly="true"
                                            @eventUp="examTypeEvent"
                                            :check-on-click-node="true"
                                            ref="studentGroupSelectTree"
                                        ></tree-select>
                                </FormItem>
                                <FormItem v-if="form.type != 3 && form.type != 11" label="是否课程学习" >
                                    <i-switch
                                        size="large"
                                        v-model="form.courseYes"
                                        :true-value="1"
                                        :false-value="0"
                                    >
                                        <span slot="open">是</span>
                                        <span slot="close">否</span>
                                    </i-switch>
                                </FormItem>
                                <FormItem v-if="form.courseYes===1" label="课程分类">
                                    <!-- 多选选择器 -->
                                    <tree-select
                                        :groupTree="courseTypes"
                                        :groupChosenIds="form.courseList"
                                        :showCheckbox="true"
                                        :checkStrictly="true"
                                        @eventUp="courseTypeEvent"
                                        :check-on-click-node="true"
                                        ref="studentGroupSelectTree"
                                    ></tree-select>
                                </FormItem>
                                <FormItem label="海报" v-if="form.type==10">
                                    <el-upload
                                        accept="image/*"
                                        class="avatar-uploader"
                                        action="#"
                                        :http-request="uploadPic"
                                        :show-file-list="false"
                                        :on-change="picHandleChange"
                                        v-model="form.pic"
                                    >
                                        <img v-if="form.pic" :src="form.pic" class="pic">
                                        <i v-else class="el-icon-plus avatar-uploader-pic"></i>
                                    </el-upload>

                                    <el-dialog width="30%" :visible.sync="dialogVisible">
                                        <img v-if="form.pic != ''" width="" :src="form.pic" alt/>
                                        <i v-else class="el-icon-plus avatar-uploader-pic"></i>
                                    </el-dialog>
                                </FormItem>
                                <FormItem label="背景图" v-if="form.type!=11" prop="icon">
                                    <el-upload
                                            accept="image/*"
                                            class="avatar-uploader"
                                            action="#"
                                            :http-request="uploadImg"
                                            :show-file-list="false"
                                            :on-change="handleChange"
                                            v-model="form.icon"
                                    >
                                        <img v-if="form.icon" :src="form.icon" class="avatar">
                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                    </el-upload>

                                    <el-dialog width="30%" :visible.sync="dialogVisible">
                                        <img v-if="form.icon != ''" width="" :src="form.icon" alt/>
                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                    </el-dialog>
                                </FormItem>
                                <FormItem label="图标" v-if="form.type==11" prop="icon">
                                    <el-upload
                                        accept="image/*"
                                        class="avatar-uploader"
                                        action="#"
                                        :http-request="uploadImg"
                                        :show-file-list="false"
                                        :on-change="handleChange"
                                        v-model="form.icon"
                                    >
                                        <img v-if="form.icon" :src="form.icon" class="icon">
                                        <i v-else class="el-icon-plus icon-uploader-icon"></i>
                                    </el-upload>

                                    <el-dialog width="30%" :visible.sync="dialogVisible">
                                        <img v-if="form.icon != ''" width="" :src="form.icon" alt/>
                                        <i v-else class="el-icon-plus icon-uploader-icon"></i>
                                    </el-dialog>
                                </FormItem>
                                <Form-item class="br" v-if="!disabledSingle">
                                    <Button type="primary" :loading="submitLoading" @click="handelSubmit"
                                            style="width:80px">提交
                                    </Button>
                                    <Button @click="handelCancel">取消</Button>
                                </Form-item>
                                <Spin size="large" fix v-if="loading"></Spin>
                            </Form>
                        </Row>
                    </Card>
                </Col>
            </Row>
        </Drawer>
    </div>
</template>
<script>
import {addSet, getExamTypeTree, getXcxDetail,selectCourseType} from "@/api/bus";
import {getExaminationType} from "@/api/examination/examination";
import uploadInput from "@/views/my-components/flyme/upload-input";
import treeSelect from "@/component/tree/treeSelect.vue";
export default {
    name: "xcxindex-drawer",
    components: {
        uploadInput,treeSelect
    },
    data() {
        return {
            examTypeShow:true,
            cerRadioShow:false,
            oldType: '',
            showUpload: false, //控制limit最大值之后 关闭上传按钮
            imageUrl: "", //上传图片后地址合集
            url: "",
            limit: 1,
            fileList: [],
            picFileList:[],
            disabled: false,
            dialogVisible: false,
            disabledSingle: false,
            readonly: true,
            picVisible: false,
            fileUrl: "",
            loading: false, // 表单加载状态
            drawerTitle: "编辑首页模块",
            drawerVisible: false,
            form: {
                title: '',
                barTitle: '',
                sort: 0,
                path: '',
                icon: '',
                examTypeList: [],
                type: 1,
                cerType:0,
                courseYes:0,
                courseList:[],
                applyYes:0,
                scoreType:0,
                orderExam:0,
                centerType:0,
                pic:'',
            },
            examTypes: [],
            courseTypes:[],
            oldExamTypes: [],
            levelTypes: [],
            submitLoading: false, // 添加或编辑提交状态
            formValidate: {
                title: [{required: true, message: "模块名称不能为空", trigger: "blur"}],
                sort: [{required: true, type: 'number', message: "排序不能为空", trigger: "blur"}],
                icon: [{required: true, message: "图标不能为空", trigger: "change"}],
            }
        };

    },
    methods: {
        showDrawer(params) {
            if (params) {
                this.drawerTitle = "编辑首页模块"
                // this.getXcxDetail(params.id);
                this.form.id = params.id
                this.form.title = params.title
                this.form.barTitle = params.barTitle
                this.form.isShow = params.isShow
                this.form.sort = params.sort
                this.form.type = params.type
                this.form.cerType = params.cerType
                this.form.oldType = params.type
                this.form.path = params.path
                this.form.icon = params.icon
                this.form.courseYes = params.courseYes
                this.form.applyYes = params.applyYes
                this.form.courseList = params.courseList
                this.form.scoreType = params.scoreType
                this.form.centerType = params.centerType
                this.form.pic = params.pic
                if (params.type == 1) {
                    if (params.examTypeList.length > 0) {
                        let arr = [];
                        for (let i = 0; i < params.examTypeList.length; i++) {
                            arr.push(parseInt(params.examTypeList[i]));
                        }
                        if (arr.length > 0) {
                            this.form.examTypeList = arr
                            //    this.$set(this.form, "examTypeList", arr)
                        }
                    } else {
                        this.form.examTypeList = params.examTypeList
                    }
                }else{
                   this.form.examTypeList = params.examTypeList
                }

            } else {
                this.drawerTitle = "新增首页模块"
                this.cleanForm()
            }
            this.drawerVisible = true;
            console.log("初始化",this.form)
        },
        cleanForm() {
            this.form.id = ''
            this.form.title = ''
            this.form.barTitle = ''
            this.form.isShow = ''
            this.form.sort = 0
            this.form.path = ''
            this.form.icon = ''
            this.form.pic = ''
            this.form.examTypeList = []
            this.form.type = 1
            this.form.courseYes = 0
            this.form.applyYes = 0
            this.form.courseList=[]
            this.form.scoreType=0
            this.form.centerType=0
        },
        uploadImg({file}) {
            console.log("上传",  this.$oss, file);
            this.$oss
                .put("/xcx/icon/" + file.uid + file.name, file)
                .then((data) => {
                    console.log(data);
                    this.form.icon = data.url;
                });
        },
        uploadPic({file}) {
            console.log("上传",  this.$oss, file);
            this.$oss
                .put("/xcx/icon/" + file.uid + file.name, file)
                .then((data) => {
                    console.log(data);
                    this.form.pic = data.url;
                });
        },
        handelSubmit() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    if (this.form.courseYes==1 && this.form.courseList.length<1) {
                        return this.$Message.error("课程分类不能为空");
                    }
                    let ossUrl = null;
                    this.submitLoading = true;
                    //上传图片到小程序xcx-icon
                    addSet(this.form).then(res => {
                        this.submitLoading = false;
                        if (res.status) {
                            this.$Message.success("操作成功");
                            this.$parent.getDataList();
                            this.drawerVisible = false;
                        } else {
                            this.$Message.error(res.info);
                            this.$parent.getDataList();
                            this.drawerVisible = false;
                        }
                    });


                }
            });
        },
        showPic(v) {
            this.fileUrl = v;
            this.picVisible = true;
        },
        handelCancel() {
            this.drawerVisible = false;
            this.cleanForm();
        },
        handleAvatarSuccess(res, file) {
            this.form.icon = URL.createObjectURL(file.raw);

        },
        handleChange(file, fileList) {
            if (fileList.length > 1) {
                fileList.splice(0, 1);
            }  // 每次上传显示的都是当前的，只能有一个（不用limit来限制了）
            // 格式无误后，预览文件处理
            this.imgSaveToUrl(file)
            // 复刻文件信息
            this.fileList = file.raw

        },
        picHandleChange(file, fileList) {
            if (fileList.length > 1) {
                fileList.splice(0, 1);
            }  // 每次上传显示的都是当前的，只能有一个（不用limit来限制了）
            // 格式无误后，预览文件处理
            this.picSaveToUrl(file)
            // 复刻文件信息
            this.picFileList = file.raw

        },
        imgSaveToUrl(file) {
            // 获取上传图片的本地URL，用于上传前的本地预览，转换后的地址为 blob:http://xxx/7bf54338-74bb-47b9-9a7f-7a7093c716b5
            this.form.icon = URL.createObjectURL(file.raw)
        },
        picSaveToUrl(file) {
            // 获取上传图片的本地URL，用于上传前的本地预览，转换后的地址为 blob:http://xxx/7bf54338-74bb-47b9-9a7f-7a7093c716b5
            this.form.pic = URL.createObjectURL(file.raw)
        },

        getExamTypes() {
            getExaminationType().then((data) => {
                this.examTypes = data.groupNodeList;
                this.oldExamTypes = data.groupNodeList;
            });

        },
        getCrouseList() {
            selectCourseType({parentId:0}).then((data) => {
                this.courseTypes = data.data;
            });
        },
        getLevelTypeList() {
            getExamTypeTree().then((data) => {
                this.levelTypes = data.data;
            });
        },
        examTypeEvent(eventDetail, treeData) {
             console.log("examTypeEvent", eventDetail,treeData);
            switch (eventDetail.type) {
                case "chosenKeysConfirm":
                    this.form.examTypeList = eventDetail.chosenKeys;
                    break;
                case "chosen":
                    console.log(eventDetail);
                    this.form.value = eventDetail.value;
                    break;
                case "select":
                    this.temporaryTree = eventDetail.value;
                    break;
                case "confirm":
                    // this.examinationType = this.temporaryTree;
                    this.form.examTypeList = this.temporaryTree.id;
                    break;
                default:
                    break;
            }
        },
        courseTypeEvent(eventDetail, treeData) {
            console.log("courseTypeEvent", eventDetail,treeData);
            switch (eventDetail.type) {
                case "chosenKeysConfirm":
                    this.form.courseList = eventDetail.chosenKeys;
                    break;
                case "chosen":
                    console.log(eventDetail);
                    this.form.value = eventDetail.value;
                    break;
                case "select":
                    this.temporaryTree = eventDetail.value;
                    break;
                case "confirm":
                    // this.examinationType = this.temporaryTree;
                    this.form.courseList = this.temporaryTree.id;
                    break;
                default:
                    break;
            }
        },

    },
    mounted() {
        this.getExamTypes();
        this.getCrouseList();
        this.getLevelTypeList();
    },
    watch: {
        'form.type'(){
            if (this.form.type!= this.form.oldType){
                this.form.examTypeList = null;
                this.cerRadioShow = false;
                if (this.form.type != 4){
                this.examTypeShow =true;
                }
            }
            if(this.form.type ==2  || this.form.type ==3 || this.form.type ==6  || this.form.type ==7 || this.form.type ==8 || this.form.type==10){
                this.cerRadioShow = false;
                this.examTypeShow =true;
            }
            if(this.form.type==4){
                this.cerRadioShow = false;
                this.examTypeShow =false;
            }
            if(this.form.type==5){
                this.cerRadioShow = true;
                this.examTypeShow =false;
            }
            if(this.form.type==11){
                this.cerRadioShow = false;
                this.examTypeShow =false;
            }

           else{
                this.examTypes = this.oldExamTypes;
                this.cerRadioShow = false;
            }
        } ,
        'form.applyYes'(){
            if(this.form.applyYes==1 || this.form.applyYes==2 ) {
                console.log("请进",1)
                this.examTypes = this.levelTypes;
            }else{
                this.examTypes = this.oldExamTypes;
            }
        },
        'form.orderExam'(){
            if(this.form.orderExam==1) {
                console.log("请进",2)
                this.examTypes = this.levelTypes;
            }else{
                this.examTypes = this.oldExamTypes;
            }
        }
    },


    };
</script>

<style>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    margin: auto;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 50px;
    line-height: 50px;
    text-align: center;
}
.avatar-uploader-pic {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 120px;
    line-height: 120px;
    text-align: center;
}
.icon-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
}
.icon {
    width: 50px;
    height: 50px;
    display: block;
}
.avatar {
    width: 150px;
    height: 50px;
    display: block;
}
.pic {
    width: 80px;
    height: 120px;
    display: block;
}
</style>